import baseApi from './baseApi';
import startupConfig from '../config/startupConfig';

const searchAbn = (keyword) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.abnSearchServiceUrl || '' : '';
  return baseApi.get(`${baseUrl}/api/v1/business/${encodeURIComponent(keyword)}`, false);
};

export default { searchAbn };
